import React from 'react';
import { Typography } from 'amphitheatre';

import UpdatePage from '../UpdatePage';

import Saber from './_img_saber_logo.png';

const { Paragraph } = Typography;

const Update3: React.FunctionComponent = () => {
  return (
    <UpdatePage title="Congratulations">
      <Paragraph>Congratulations on finishing your Quest For Blue.</Paragraph>
      <Paragraph>
        Thank you for entering our inaugural competition and enthusiastically
        taking on the challenge to design a space mission. We’re currently
        reading through all your submissions and we’re impressed with the
        quality of work so far. We’ll get back to you about the results as soon
        as we can. Hold steady!
      </Paragraph>
      <Paragraph>
        Whilst you’re waiting, you’re welcome to keep using the P.I.G.I.
        subscription through your Quest For Blue/Saber login details. Keep
        refining your ideas and exploring the entrepreneurial possibilities of
        space.
      </Paragraph>
      <Paragraph>
        <img src={Saber} alt="signature" height="64px" />
      </Paragraph>
      <Paragraph>Saber Astronautics Team</Paragraph>
    </UpdatePage>
  );
};

export default Update3;
